<canvas id="parallelogram" #parallelogram width="100" height="280" style="margin: auto; display: block;"></canvas>
